import { createStore, combineReducers } from 'redux'
import { persistStore, persistReducer, createMigrate } from 'redux-persist'

import { reduxStorage } from './storage'

import contentFilter from './reducers/contentFilter'
import localization from './reducers/localization'
import pageInfo from './reducers/pageInfo'
import connectionStatus from './reducers/connectionStatus'
import newsStatus from './reducers/newsStatus'
import webToPrint from './reducers/webToPrint'
import { tco } from './tco/store/reducer'

const rootReducer = combineReducers({
  contentFilter,
  localization,
  pageInfo,
  connectionStatus,
  newsStatus,
  webToPrint,
  tco
})

// use persitor.purge() to purge total persisted state
const migrations = {
  1: state => {
    return {
      language: state.language
    }
  }
}

// persist
const persistConfig = {
  key: 'root',
  version: 1,
  storage: reduxStorage,
  blacklist: ['contentFilter', 'pageInfo', 'connectionStatus', 'webToPrint', 'tco'],
  migrate: createMigrate(migrations)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const persistor = persistStore(store)

export { store, persistor }



// WEBPACK FOOTER //
// ./src/reduxStore.js